var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getResources } from 'app/store/selectors/getResources';
import { filter, values, isEqual } from 'lodash';
import { MUIModal } from 'app/components/Modal';
import DashboardWidgets from 'app/pages/Project/ProductionManagement/Dashboards/DashboardWidgets/DashboardWidgets';
import { widgetsByDashboardSelector } from 'app/store/selectors/widgets';
import { fetchDashboardData, fetchOneDashboard, updateDashboard } from 'app/store/reducers/dashboards';
import { selectedDashboardSelector } from 'app/store/selectors/dashboards';
import resources from 'app/store/resources';
import { WIDGET_TYPES } from 'app/pages/Project/ProductionManagement/Dashboards/constants';
import Loader from 'app/components/Loader/Loader.jsx';
import { success } from 'app/components/Notifications/notify';
import { Divider, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { colors } from 'app/styles/vars.js';
import { MUIButton } from 'app/components/Form';
import classes from './styles.scss';
import { confirmDelete } from 'app/components/Modal';
const ModalEditDashboardLayout = (_a) => {
    var _b, _c, _d, _e;
    var { projectId, dashboardId } = _a, modalprops = __rest(_a, ["projectId", "dashboardId"]);
    const dispatch = useDispatch();
    const isWidgetSupervisor = (widget, allWidgets) => {
        const widgetHasParent = Boolean(widget.parent);
        if (!widgetHasParent && !widget.rel_dashboardWidgetInst.isSupervisor) {
            return false;
        }
        if (widgetHasParent) {
            const widgetParent = allWidgets.find((wid) => wid.id === widget.parent);
            if (widgetParent) {
                const isSupervisor = widget.rel_dashboardWidgetInst.isSupervisor || isWidgetSupervisor(widgetParent, allWidgets);
                return isSupervisor;
            }
        }
        return true;
    };
    const activeDashboard = useSelector(selectedDashboardSelector(dashboardId));
    const dashboardWidgets = useSelector(widgetsByDashboardSelector(dashboardId));
    const allEpisodes = useSelector((state) => filter(state.assets.resources, (asset) => asset.assetType === 'ep'));
    const stepProjects = getResources(undefined, 'steps');
    const progressionStatus = getResources(undefined, 'progressionStatus');
    const [viewMode, setViewMode] = useState('public');
    const [loading, setLoading] = useState(true);
    const [dashboardLayout, setDashboardLayout] = useState([]);
    const [activeEpisodesByWidget, setActiveEpisodesByWidget] = useState([]);
    const widgets = viewMode === 'sup'
        ? dashboardWidgets
        : dashboardWidgets.filter((widget) => !isWidgetSupervisor(widget, dashboardWidgets));
    const saveLayoutInDB = () => __awaiter(void 0, void 0, void 0, function* () {
        const updatedDashboard = Object.assign(Object.assign({}, activeDashboard), { config: Object.assign(Object.assign({}, activeDashboard.config), { layouts: Object.assign(Object.assign({}, activeDashboard.config.layouts), { [viewMode]: dashboardLayout }) }) });
        yield dispatch(updateDashboard(updatedDashboard));
        success('Layout saved');
    });
    const onChangeViewMode = (_, value) => {
        if (value !== null) {
            setViewMode(value);
        }
    };
    const saveDashboardLayoutLocally = (newLayouts) => {
        setDashboardLayout((prevState) => {
            const updatedLayout = prevState.map((layout) => {
                const el = newLayouts.find((nl) => nl.i === layout.i);
                if (el) {
                    return Object.assign(Object.assign({}, layout), { h: el.h, w: el.w, x: el.x, y: el.y });
                }
                return layout;
            });
            return updatedLayout;
        });
    };
    const generateLayouts = (widgets) => {
        var _a;
        const savedLayout = (_a = activeDashboard.config.layouts) === null || _a === void 0 ? void 0 : _a[viewMode];
        // generate layout from saved layout in dashboard config if it exists
        if (savedLayout) {
            const layouts = widgets.map((widget) => {
                const savedWidgetLayout = savedLayout === null || savedLayout === void 0 ? void 0 : savedLayout.find((lay) => lay.i === widget.id);
                if (savedWidgetLayout) {
                    return savedWidgetLayout;
                }
            });
            return layouts;
        }
        // else generate default layout
        const layouts = widgets.map((widget) => {
            if (widget.widgetType === WIDGET_TYPES.CONTAINER) {
                return {
                    w: 6,
                    h: 22,
                    x: 0,
                    y: 0,
                    i: widget.id,
                    name: widget.name,
                    moved: false,
                    static: false,
                };
            }
            return {
                w: 6,
                h: 10,
                x: 0,
                y: 0,
                i: widget.id,
                name: widget.name,
                moved: false,
                static: false,
            };
        });
        return layouts;
    };
    const onRestoreDefaultLayout = () => {
        confirmDelete({
            title: 'Restore default layout',
            render: 'Are you sure you want to restore the default layout ?',
            validateLabel: 'Yes',
            onValidate: () => {
                const layouts = generateLayouts(widgets);
                setDashboardLayout(layouts);
            },
            validateMessage: 'Local layout removed',
        });
    };
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(true);
            const promises = [
                dispatch(fetchOneDashboard(dashboardId)),
                dispatch(fetchDashboardData(activeDashboard.id)),
                !allEpisodes.length && resources.assets.fetchEpisodes(projectId),
                !values(stepProjects).length && resources.steps.fetchByProject(projectId),
            ];
            yield Promise.all(promises);
            setLoading(false);
        }))();
    }, []);
    useEffect(() => {
        if (!loading) {
            const generatedLayouts = generateLayouts(widgets);
            const actEpisodes = widgets.map((widget) => {
                var _a;
                return {
                    widgetId: widget.id,
                    episodes: (_a = widget.config.episodes) !== null && _a !== void 0 ? _a : [],
                };
            });
            setActiveEpisodesByWidget(actEpisodes);
            setDashboardLayout(generatedLayouts);
        }
    }, [loading, viewMode]);
    return (_jsx(MUIModal, Object.assign({ title: `Edit ${activeDashboard.name} layout (${viewMode} view)`, validateLabel: "Save", loading: loading, disableValidate: isEqual(dashboardLayout, (_b = activeDashboard === null || activeDashboard === void 0 ? void 0 : activeDashboard.config.layouts) === null || _b === void 0 ? void 0 : _b[viewMode]) ||
            (!dashboardLayout.length && !((_c = activeDashboard === null || activeDashboard === void 0 ? void 0 : activeDashboard.config.layouts) === null || _c === void 0 ? void 0 : _c[viewMode])), onValidate: saveLayoutInDB, resizable: false, width: "100vw", minHeight: "85vh", childreContainerStyle: {
            padding: 0,
            minHeight: '80vh',
            display: loading ? 'flex' : 'initial',
            justifyContent: loading ? 'center' : 'initial',
            alignItems: loading ? 'center' : 'initial',
        } }, modalprops, { children: loading ? (_jsx(Loader, {})) : (_jsxs("div", { className: "fullHeight overflowYAuto relative marginLeft10 marginRight10", children: [_jsxs(ToggleButtonGroup, { style: {
                        border: `1px solid ${colors.yuzuBlackLight}`,
                        height: '30px',
                        marginRight: 10,
                    }, size: "small", value: viewMode, exclusive: true, onChange: onChangeViewMode, children: [_jsx(ToggleButton, { disableRipple: true, className: classes.toggleBtn, style: {
                                backgroundColor: viewMode === 'sup' ? colors.yuzuPrimaryColor : 'initial',
                            }, value: "sup", children: "Sup view" }), _jsx(ToggleButton, { disableRipple: true, className: classes.toggleBtn, style: {
                                backgroundColor: viewMode === 'public' ? colors.yuzuPrimaryColor : 'initial',
                            }, value: "public", children: "Public view" })] }), _jsx(MUIButton, { style: { marginLeft: '10px', padding: '0 10px' }, bgColor: "#E56D7A", onClick: onRestoreDefaultLayout, disabled: isEqual(dashboardLayout, (_d = activeDashboard === null || activeDashboard === void 0 ? void 0 : activeDashboard.config.layouts) === null || _d === void 0 ? void 0 : _d[viewMode]) ||
                        (!dashboardLayout.length && !((_e = activeDashboard === null || activeDashboard === void 0 ? void 0 : activeDashboard.config.layouts) === null || _e === void 0 ? void 0 : _e[viewMode])), children: "Restore default layout" }), _jsx(Divider, { style: { marginTop: '17px' } }), _jsx(DashboardWidgets, { allEpisodes: allEpisodes, allLayouts: dashboardLayout, widgets: widgets, stepProjects: stepProjects, dashboardLayout: dashboardLayout, progressionStatus: progressionStatus, nested: false, activeEpisodesByWidget: activeEpisodesByWidget, setActiveEpisodesByWidget: setActiveEpisodesByWidget, saveDashboardLayoutLocally: saveDashboardLayoutLocally, fromSettings: true })] })) })));
};
export default ModalEditDashboardLayout;
